"use client";

import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from "react";

const navigationItems = [
    { name: "Home", href: "/" },
    { name: "People", href: "/people" },
    { name: "Projects", href: "/projects" },
    { name: "Publications", href: "/publications" },
    { name: "Datasets", href: "/datasets" },
    { name: "Software", href: "/software" },
    { name: "Posts", href: "/posts" },
    { name: "Events", href: "/events" }
];

export default function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.scrollY > 50;
            setIsScrolled(scrolled);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <nav className={`bg-background backdrop-blur-md border-b border-gray-200 sticky top-0 z-50 transition-all duration-300 ease-in-out ${
            isScrolled ? 'shadow-lg' : 'shadow-sm'
        }`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className={`flex justify-between items-center transition-all duration-300 ease-in-out ${
                    isScrolled ? 'h-16' : 'h-25'
                }`}>
                    <div className="flex items-center">
                        <Link href="/" className="flex-shrink-0 flex items-center space-x-3">
                            <Image 
                                src="/New_NITK_Logo.png" 
                                alt="New_NITK_Logo" 
                                width={1024} 
                                height={1024} 
                                className={`transition-all duration-300 ease-in-out ${
                                    isScrolled ? 'h-11 w-11' : 'h-22 w-22'
                                }`} 
                            />
                            <div className="flex flex-col">
                                <span className={`font-bold text-primary transition-all duration-300 ease-in-out ${
                                    isScrolled ? 'text-lg' : 'text-xl'
                                }`}>
                                    HALE Lab
                                </span>
                                <span className={`text-gray-600 transition-all duration-300 ease-in-out ${
                                    isScrolled ? 'text-xs opacity-0 h-0' : 'text-sm opacity-100 h-auto'
                                }`}>
                                    Healthcare Analytics & Language Engineering 
                                   
                                </span>
                                <span className={`text-gray-600 transition-all duration-300 ease-in-out ${
                                    isScrolled ? 'text-xs opacity-0 h-0' : 'text-sm opacity-100 h-auto'
                                }`}>
                                    National Institute of Technology Karnataka, Surathkal
                                   
                                </span>
                            </div>
                        </Link>
                    </div>
                    
                    <div className="hidden md:block">
                        <div className="ml-10 flex items-baseline">
                            {navigationItems.map((item) => (
                                <Link
                                    key={item.name}
                                    href={item.href}
                                    className={`text-gray-700 hover:text-primary border-b-2 border-transparent hover:border-primary
                                        active:border-primary-foreground focus:outline-none focus:border-primary
                                        px-3 py-2 font-medium transition-colors duration-200 ease-in-out ${
                                        isScrolled ? 'text-sm' : 'text-base'
                                    }`}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                    </div>
                    
                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            type="button"
                            onClick={toggleMobileMenu}
                            className={`text-gray-700 hover:text-primary focus:outline-none focus:text-primary transition-all duration-200 ease-in-out transform hover:scale-110 ${
                                isScrolled ? 'p-1' : 'p-2'
                            }`}
                            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
                        >
                            {isMobileMenuOpen ? (
                                <svg className={`transition-all duration-300 ease-in-out ${
                                    isScrolled ? 'h-5 w-5' : 'h-6 w-6'
                                }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className={`transition-all duration-300 ease-in-out ${
                                    isScrolled ? 'h-5 w-5' : 'h-6 w-6'
                                }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>

            {isMobileMenuOpen && (
                <div className="md:hidden">
                    <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-200 bg-white/95 backdrop-blur-md">
                        {navigationItems.map((item) => (
                            <Link
                                key={item.name}
                                href={item.href}
                                onClick={() => setIsMobileMenuOpen(false)}
                                className="text-gray-700 hover:text-primary hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ease-in-out"
                            >
                                {item.name}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
            </div>
        </nav>
    );
}
